import { useI18n } from '@/context/I18nContext';

export function LoadingSpinner({ message }: { message?: string }) {
  const { t } = useI18n();

  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <div className="w-8 h-8 border-2 border-accent/30 border-t-accent rounded-full animate-spin" />
      <span className="text-sm text-text-secondary">{message ?? t('common.loading')}</span>
    </div>
  );
}
